import { useState } from 'react';
import cn from 'classnames';
import { StyledAdminGroupsSelect } from './styles';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-full.svg';
import { IAdminDeviceGroup, TNormalizedDeviceGroups } from 'types';
import { TNullable } from 'types/common';
import { AdminDropdown } from '../AdminDropdown';
import { AdminDropdownOption } from '../AdminDropdownOption';

interface IAdminGroupsSelectProps {
  groups: TNormalizedDeviceGroups;
  currentGroupId: TNullable<IAdminDeviceGroup['id']>;
  onSelect: (groupId: IAdminDeviceGroup['id']) => void;
}

export const AdminGroupsSelect = ({
  groups,
  onSelect,
  currentGroupId,
}: IAdminGroupsSelectProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const selectGroupHandler = (id: IAdminDeviceGroup['id']) => () => {
    onSelect(id);
    setIsCollapsed(true);
  };

  const toggleDropdownHandler: React.MouseEventHandler<HTMLDivElement> = () => {
    setIsCollapsed((prev) => !prev);
  };

  const collapseDropdownHandler: React.MouseEventHandler<HTMLDivElement> = () => {
    setIsCollapsed(true);
  };

  return (
    <StyledAdminGroupsSelect>
      <div className="selected-group" onClick={toggleDropdownHandler}>
        <div className="selected-group-name">
          {currentGroupId ? groups.byID[currentGroupId]?.name : '---'}
        </div>
        <div className={cn('drop-down-arrow', isCollapsed && 'collapsed')}>
          <ArrowDownIcon />
        </div>
      </div>
      {!isCollapsed && (
        <AdminDropdown onMouseLeave={collapseDropdownHandler}>
          {groups.allIDs
            .filter((id) => id !== currentGroupId)
            .map((id) => (
              <AdminDropdownOption
                key={id}
                current={currentGroupId === id}
                onClick={selectGroupHandler(id)}
              >
                {groups.byID[id].name}
              </AdminDropdownOption>
            ))}
        </AdminDropdown>
      )}
    </StyledAdminGroupsSelect>
  );
};
